(function(){
    angular.module("tmx-common").directive('tmxHeaderCards',tmxHeaderCards);

    function tmxHeaderCards(){
        return {
            scope:{
                model:"=",
                form:"=",
                readonly:"=",
                disabled:"=",
                unit: "@",
                leftValue:"=",
                rightValue:"=",
                title:"@",
                icon:"@",
                entity:"@",
                submitted:"=",
                multiple:"=",
                leftLabel:"@?",
                rightLabel:"@?"
            },
            restrict: 'E',
            templateUrl:"common/directives/tmxHeaderCards/tmxHeaderCards.html",
            controller:tmxHeaderCardCtrl,
            controllerAs:"HeaderCardCtrl"
        }
       
    }


    function tmxHeaderCardCtrl($scope){

        var vm=this;
        vm.showValidityMailingAddress=false;
        vm.title = $scope.title;
    
        vm.icon = $scope.icon;
        vm.unit = $scope.unit;
        vm.entity=$scope.entity;
        vm.submitted=$scope.submitted;
        vm.doneButtonClicked=true;
        //variables for checking address validity
        vm.isFirstAddressValid=false;
        vm.isSecondAddressValid=false;
        vm.isThirdAddressValid=false;
        vm.showValidity1=false;
        vm.showValidity2=false;
        vm.scope = $scope;
        vm.defaultCountryId;
        vm.lookup = {};
        vm.lookup = {};
        var loaded = false;
        vm.myStyle={"background-color": "#08B7A1"}


    }


})();